<template>
	<div style="height: 100%;width: 100%;" id="wifiMap">
		<groupDiv></groupDiv>
	
	</div>
</template>

<script>
	// import gaodeMap from "../../js/GaodeMapMethod.js"
	import groupDiv from "./groupDiv.vue"
	export default {
		data() {
			return {
				map: null,
				features: [{
					type: "wifiOnline",
					LngLat: [116.355428, 39.99123]
				}, {
					type: "wifiError",
					LngLat: [116.354428, 39.98223]
				}, {
					type: "wifiBug",
					LngLat: [116.363428, 39.97323]
				}, {
					type: "wifiOnline",
					LngLat: [116.392428, 39.96423]
				}, {
					type: "wifiOnline",
					LngLat: [116.311428, 39.95523]
				}]

			}
		},
		components:{
			groupDiv:groupDiv
		},
		mounted() {
			// gaodeMap.initMap("wifiMap", 10, null);
			console.log("123123123123")
			// gaodeMap.getSelfMap("深圳");
			// gaodeMap.createMarkeList(this.features)
		},
		methods: {


		}
	}
</script>

<style>
	.group {
		width: 12%;
		height: 100%;
		position: absolute;
		z-index: 1;
		/* background-color: black; */



		background-color: #191730;

	}

	.top {
		width: 97%;
		height: 80px;
		margin: 10px auto;
		color: white
	}


	.leader {
		width: 99%;
		height: 50px;
		line-height: 50px;
		font-size: 15px;
		text-align: left;
		padding-left: 10px;


	}

	.groupPer {
		width: 99%;

		text-align: left;
		padding-left: 10px;
		font-size: 13px;

	}

	.leader,
	.groupPer {
		color: #65CE90;
		background-color: #23223F;
	}
.groupPer_{
	margin-bottom: 5px;
	margin-left: 2px;
}
	.ifDisplay {
		display: none;
	}

	.persionGroup {
		margin-bottom: 5px;
		padding: 0 5px;
	}

	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	/**
	 * 1.在元素被插入之前生效，在元素被插入之后的下一帧移除。
	 * 2.在整个进入过渡的阶段中应用，在元素被插入之前生效，在过渡/动画完成之后移除。
	 * 3.在元素被插入之后下一帧生效 (与此同时 v-enter 被移除)，在过渡/动画完成之后移除。
	 * 
	 * 4.在离开过渡被触发时立刻生效，下一帧被移除。
	 * 5.在整个离开过渡的阶段中应用，在离开过渡被触发时立刻生效，在过渡/动画完成之后移除。
	 * 6.在离开过渡被触发之后下一帧生效 (与此同时 v-leave 被删除)，在过渡/动画完成之后移除。
	 * 
	 */
	.slide-fade-enter {
		transform: translateY(-30px);
		opacity: 0;
	}

	.slide-fade-enter-active {
		transition: all .5s ease;
	}

	.slide-fade-enter-to {}

	.slide-fade-leave {}

	.slide-fade-leave-active {
		transition: all .5s ease;
	}


	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateY(-30px);
		opacity: 0;

	}
</style>
